var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgSave = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M7.75,3.75 L7.75,7.25 L15,7.25 C15.4142136,7.25 15.75,7.58578644 15.75,8 C15.75,8.41421356 15.4142136,8.75 15,8.75 L7,8.75 C6.58578644,8.75 6.25,8.41421356 6.25,8 L6.25,3.75 L5,3.75 C4.30964406,3.75 3.75,4.30964406 3.75,5 L3.75,19 C3.75,19.6903559 4.30964406,20.25 5,20.25 L6.25,20.25 L6.25,13 C6.25,12.5857864 6.58578644,12.25 7,12.25 L17,12.25 C17.4142136,12.25 17.75,12.5857864 17.75,13 L17.75,20.25 L19,20.25 C19.6903559,20.25 20.25,19.6903559 20.25,19 L20.25,8.31066017 L15.6893398,3.75 L7.75,3.75 Z M16.25,20.25 L16.25,13.75 L7.75,13.75 L7.75,20.25 L16.25,20.25 Z M19,21.75 L5,21.75 C3.48121694,21.75 2.25,20.5187831 2.25,19 L2.25,5 C2.25,3.48121694 3.48121694,2.25 5,2.25 L16,2.25 C16.1989124,2.25 16.3896778,2.32901763 16.5303301,2.46966991 L21.5303301,7.46966991 C21.6709824,7.6103222 21.75,7.80108763 21.75,8 L21.75,19 C21.75,20.5187831 20.5187831,21.75 19,21.75 Z"
  }));
};
export default SvgSave;